<template>
  <v-select
    v-model="model"
    :items="items"
    :label="label"
    :prepend-icon="icon"
    :clearable="true"
    multiple
    chips
    deletable-chips
    dense
    item-text="name"
    item-value="id"
    @change="signalChange"
  ></v-select>
</template>

<script>
export default {
  name: "StoreSelectMultiple",
  props: {
    autoclear: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "mdi-store",
    },
    label: {
      type: String,
      default: "Store",
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    items: [],
    loading: false,
    search: "",
  }),
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    model() {
      this.$nextTick(() => {
        if (this.autoclear) {
          this.search = "";
          this.model = [];
        }
      });
    },
    search() {
      this.getStores();
    },
  },
  mounted() {
    this.getStores();
  },
  methods: {
    signalChange: function (event) {
      this.$emit("change", event);
    },
    getStores() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let filter = {
        page: {
          number: 1,
          size: 200,
        },
        filter: {},
      };
      if (this.search) {
        filter.filter.search = this.search;
      }
      this.$models.Store.all(filter)
        .then((response) => {
          this.items = response.data;
          this.items.push(...this.model);
          this.loading = false;
        })
        .catch((error) => {
          this.$bus.$emit("Error", error);
        });
    },
  },
};
</script>
